import { render, staticRenderFns } from "./shift-view-payment.vue?vue&type=template&id=5a23db20&scoped=true"
import script from "./shift-view-payment.vue?vue&type=script&lang=js"
export * from "./shift-view-payment.vue?vue&type=script&lang=js"
import style0 from "./shift-view-payment.vue?vue&type=style&index=0&id=5a23db20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23db20",
  null
  
)

export default component.exports